import { useSyncExternalStore } from 'preact/compat';
import type { State } from '@ordergroove/offers/types';
import type { Store } from 'redux';

export type { State as OffersState };

export function getOffersStore(): Store<State> {
  const store = window.og?.store as Store<State> | undefined;
  if (!store) throw new Error('Offers store not found. Ensure main.js is loaded.');
  return store;
}

/**
 * Preact hook that subscribes to the offers Redux store and re-renders when the selected value changes.
 * @param selector - Function that extracts a value from the offers store state.
 * @returns The current selected value, updated on every store change.
 */
export function useOffersSelector<T>(selector: (state: State) => T): T {
  const store = getOffersStore();
  return useSyncExternalStore(store.subscribe, () => selector(store.getState()));
}
